import { __assign, __rest } from "tslib";
import React from 'react';
import { TableBodyCell } from '../styled/TableCell';
import { TableBodyRow } from '../styled/TableRow';
var Row = function (_a) {
    var row = _a.row, head = _a.head, testId = _a.testId, isFixedSize = _a.isFixedSize, isHighlighted = _a.isHighlighted;
    var cells = row.cells, restRowProps = __rest(row, ["cells"]);
    return (React.createElement(TableBodyRow, __assign({}, restRowProps, { isHighlighted: isHighlighted, "data-testid": testId && testId + "--row-" + restRowProps.key }), cells.map(function (cell, cellIndex) {
        var content = cell.content, restCellProps = __rest(cell, ["content"]);
        var _a = (head || { cells: [] }).cells[cellIndex] || {}, shouldTruncate = _a.shouldTruncate, width = _a.width;
        return (React.createElement(TableBodyCell, __assign({ "data-testid": testId && testId + "--cell-" + cellIndex }, restCellProps, { isFixedSize: isFixedSize, key: cellIndex, shouldTruncate: shouldTruncate, width: width }), content));
    })));
};
export default Row;
//# sourceMappingURL=TableRow.js.map